import React, { useEffect } from 'react';
import "./CabDecesion.css";
import prevIcon from "../../../assets/icons/coloredPrev.svg";
import icon from "../../../assets/icons/ChatText.svg"
import { useNavigate,useLocation } from 'react-router-dom';
import axios from 'axios';
import useAuth from '../../../customHooks/useAuth';
import { toast } from 'react-toastify';
import { baseUrl } from '../../../common/baseUrl';


// React Redux 
import { useDispatch } from 'react-redux';
import {setCabRequests} from "../../../redux/userSlice"
import axiosInstance from '../../../axiosInstance/axiosInstance';
import { HOTEL_TIMEZONE } from "../../../common/hotelTime";

export default function CabDecesion() {

    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();



    // Setting UP Cab Request Data
    const cabRequestData = location.state?.cabRequestData || {};
    const hotelId = location.state?.hotelId || "";
    const bookingId = location.state?.bookingId || "";

    // Check If It is Empty then Go To the Bookings
    useEffect(()=>{
        const checkData = ()=>{
            if(hotelId==="" || bookingId==="" ||  Object.keys(cabRequestData).length === 0){ 
                navigate("/bookings",{state : {activeRequests : "requests"}});
            }
        }
        checkData();
    },[])

    // Reject Fee
    const handleRejectFee = async() =>{
        try{
            const formData = {accepted_by_guest : false};

            // console.log("Hotel Id : " + hotelId);
            // console.log("Booking Id : " + bookingId);
            // console.log("Cab Request Id : " + cabRequestData.id);
            // console.log("Booked Room ID : " + cabRequestData.booked_room_id);
        

            const response = await axiosInstance.patch(`/api/v1/users/${cabRequestData.user_id}/bookings/${bookingId}/booked-rooms/${cabRequestData.booked_room_id}/guest-requests/pre-checkin/cab-request/user-verdict?guest_request_id=${cabRequestData.guest_request_id}`,formData);

            // console.log("Response : ",response.data);


            // try{
            //     const response2 = await axiosInstance.get(`/api/v1/users/${cabRequestData.user_id}/requests`);

            //     console.log("Respose Data in Cab Decision : ",response2.data.data);
        
            //     dispatch(setCabRequests(response2.data.data));

                
            // }catch(error){
            //     console.log(error);
            // }

            toast.success("PreCheckIn Cab Request Fee Rejected Successfully");
            navigate("/bookings",{state : {activeRequests : "requests"}})

        }
        catch(error){
            toast.error(error?.response?.data?.message || "Some Error Occurred");
            console.log(error);
        }
    }

    // Accept Fee
    const handleAcceptFee = async() =>{

        try{
            const formData = {accepted_by_guest : true};

            // console.log("Hotel Id : " + hotelId);
            // console.log("Booking Id : " + bookingId);
            // console.log("Cab Request Id : " + cabRequestData.id);
            // console.log("Booked Room ID : " + cabRequestData.booked_room_id);

            const response = await axiosInstance.patch(`/api/v1/users/${cabRequestData.user_id}/bookings/${bookingId}/booked-rooms/${cabRequestData.booked_room_id}/guest-requests/pre-checkin/cab-request/user-verdict?guest_request_id=${cabRequestData.guest_request_id}`,formData);
        
            // console.log("Response : ",response.data);

            toast.success("PreCheckIn Cab Request Fee Accepted Successfully");

            // try{
            //     const response2 = await axiosInstance.get(`/api/v1/users/${cabRequestData.user_id}/requests`);

            //     console.log("Respose Data in Cab Decision : ",response2.data.data);
        
            //     dispatch(setCabRequests(response2.data.data));

                
            // }catch(error){
            //     console.log(error);
            // }
            navigate("/bookings",{state : {activeRequests : "requests"}})

        }
        catch(error){
            toast.error(error?.response?.data?.message || "Some Error Occured");
            console.log(error);
        }

    }



    // Format Date 
    // const formatDateToISO = (dateStr) => {
    //     const date = new Date(dateStr);
    //     const year = date.getUTCFullYear();
    //     const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    //     const day = String(date.getUTCDate()).padStart(2, '0');
    //     const hours = String(date.getUTCHours()).padStart(2, '0');
    //     const minutes = String(date.getUTCMinutes()).padStart(2, '0');
        
    //     // Format as "YYYY-MM-DDTHH:mm"
    //     return `date : ${day}-${month}-${year}  time : ${hours}:${minutes}`;
    // };


    // Refresh Handle
    useAuth();



    // Function to format the date (e.g., "07 Oct")
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = date.getDate();
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];
        const month = monthNames[date.getMonth()];
        return `${day} ${month}`;
    };

    // Function to extract the year (e.g., "2024")
    const formatYear = (dateString) => {
        const date = new Date(dateString);
        const year = date.getFullYear(); // Extracts the full year (e.g., "2024")
        return year;
    };

    // Function to format the time (e.g., "22:11")
    const formatTimePeriod = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleTimeString([], {
            timeZone: HOTEL_TIMEZONE, hour: '2-digit', minute: '2-digit' });
    };
         
    // It is Handle goto previous page
    const handleClick=()=>{
        navigate("/bookings",{state : {activeRequests : "requests"}})
    }

  return (
    <div className='cab-decesion'>

        {/* Cab Header */}
        <div className='cab-decesion-header'>
            <div className="cab-decesion-content">
                <div className='prev-icon' onClick={handleClick}>
                    <img src={prevIcon} alt="" />
                </div>
                <div className='cab-decesion-data'>
                    <div className='cab-decesion-data-header'>
                        <h6>
                        Book your cab to your stay
                        </h6>
                        <p>
                        Reserve a comfortable and reliable transportation option for your convenient journey.
                        </p>
                    </div>
                </div>
            </div>
        </div>

        {/* Cab Pickup Message */}
        <div className="cab-pickup-msg">    
            {/* Pickup Location */}
            <div className="pickup-location">
                <div className="msg-header">
                    <h4>Pick Up Location</h4>
                </div>
                <div className="pickup-msg">
                    <h6>{cabRequestData.pick_up_location}</h6>
                </div>
            </div>
            
            {/* Cab Time Message */}
            <div className="cab-time">
                <div className="msg-header">
                    <h4>When do you want cab ?</h4>
                </div>
                <div className="cab-time-msg">
                  
                   <h6>
                        {/* cabRequestData.time_of_arrival */}
                        {/* {formatDateToISO(cabRequestData.time_of_arrival)} */}
                        {formatDate(cabRequestData.time_of_arrival)}-
                        {formatYear(cabRequestData.time_of_arrival)}-
                        {formatTimePeriod(cabRequestData.time_of_arrival)}
                   </h6>
                </div>
            </div>

            {/* Cab Fee Requested */}
            <div className="cab-fee">
                <div className="msg-header">
                    <h4>Fee Requested By Hotel</h4>
                </div>
                <div className="cab-fee-msg">
                    <h6>
                        ₹ {cabRequestData.price}
                    </h6>
                </div>
            </div>
        </div>

        {/* Hotel Remark */}
        {cabRequestData.remarks && 
            <div className="hotel-remark">
                <div className="icon-hotel">
                    <img src={icon} alt='' />
                </div>
                
                    <div className="hotel-msg">
                        <div className="hotel-msg-header">
                            <h5>
                                Remarks By Hotel : 
                            </h5>
                            <p>
                            {cabRequestData.remarks}
                            </p>
                        </div>
                    </div>
            

            </div>
        }
  
        {/* Fee Buttons */}
        <div className="fee-btns">
            <div className="reject-btn">
                <button onClick = {handleRejectFee}>Reject Fee</button>
            </div>
            <div className="accept-btn">
                <button onClick = {handleAcceptFee}>Accept Fee</button>
            </div>
        </div>
        
    </div>
  )
}
